import api from '@/utils/httpClient';
import { ApiListResponse } from '@oncolens/oncolens-ui/lib/dto/api/ApiResponse';
import { useQuery, UseQueryOptions } from 'react-query';
import { WorkflowDto } from "@/features/requests/api/getWorkflow";


export const getWorkflows = () => {
	return api
		.get('/api/collaborationworkflows')
		.then((response) => (response.data as ApiListResponse<WorkflowDto>).data);
};

export const useGetWorkflows = (options?: UseQueryOptions<WorkflowDto[]>) => {
	return useQuery('workflows', () => getWorkflows(), {
		...options,
		refetchOnWindowFocus: false,
		cacheTime: Infinity,
		staleTime: Infinity
	});
};
